import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { Field } from 'react-final-form';
import { Form } from 'react-final-form';
import { Container, Row, Col } from 'react-bootstrap';
import { decamelizeKeys } from 'humps';
import cx from 'classnames';

import Step from './Step';
import LanguageLevelSelect from './LanguageLevelSelect';
import Input from '../Forms/Input';
import RadioButtonGroup from '../Forms/RadioButtonGroup';
import API from '../../services/API';
import Button from '../UI/Button';
import Tabs from '../UI/Tabs';
import * as formValidators from '../../utils/formValidation';
import { routerPush, routerSetWindowLocation } from '../../utils/router';
import { withTranslation } from '../../i18n';
import styles from './styles.css';

class StepSkills extends PureComponent {
  state = {
    isSubmitting: false,
  };

  handleSubmit = async formValues => {
    this.setState({ isSubmitting: true });

    const updatedServiceProfile = await API.fetch(
      undefined,
      '/user/service-profile-skills/update',
      decamelizeKeys(formValues),
    );

    this.props.setServiceProfile(updatedServiceProfile);

    routerPush('/profile');
    // routerSetWindowLocation('/profile');
  };

  getInitialValues() {
    const { serviceProfile } = this.props;
    const defaults = {
      languageLevelDutch: 'beginner',
      languageLevelFrench: 'beginner',
      languageLevelEnglish: 'beginner',
    };

    if (!serviceProfile) {
      return {};
    }

    return {
      ...serviceProfile,
      firstAidCertificate: serviceProfile.firstAidCertificate ? 'yes' : 'no',
      languageLevelDutch: serviceProfile.languageLevelDutch || defaults.languageLevelDutch,
      languageLevelFrench: serviceProfile.languageLevelFrench || defaults.languageLevelFrench,
      languageLevelEnglish: serviceProfile.languageLevelEnglish || defaults.languageLevelEnglish,
    };
  }

  validateForm = formValues => {
    const { serviceProfile, t } = this.props;
    const errors = {};
    const isMediaCrew = serviceProfile.crewType === 'media_crew';

    formValidators.required(formValues, errors, 'languageLevelDutch');
    formValidators.required(formValues, errors, 'languageLevelFrench');
    formValidators.required(formValues, errors, 'languageLevelEnglish');
    formValidators.required(formValues, errors, 'talent');

    if (isMediaCrew) {
      formValidators.required(formValues, errors, 'firstAidCertificate');
    }

    return errors;
  };

  render() {
    const { visible, goToPreviousStep, serviceProfile, t } = this.props;
    const { isSubmitting } = this.state;
    const isMediaCrew = serviceProfile.crewType === 'media_crew';

    return (
      <Step visible={visible}>
        <Form
          onSubmit={this.handleSubmit}
          initialValues={this.getInitialValues()}
          validate={this.validateForm}
          render={({ handleSubmit, pristine, invalid }) => (
            <form onSubmit={handleSubmit}>
              <Row>
                <Col className="mb-3" xs={12} md={4}>
                  <LanguageLevelSelect language="dutch" label={t('languageNL')} />
                </Col>
                <Col className="mb-3" xs={12} md={4}>
                  <LanguageLevelSelect language="english" label={t('languageEN')} />
                </Col>
                <Col className="mb-3" xs={12} md={4}>
                  <LanguageLevelSelect language="french" label={t('languageFR')} />
                </Col>
              </Row>

              {!isMediaCrew && (
                <div className="mb-3">
                  <Field
                    component={RadioButtonGroup}
                    name="firstAidCertificate"
                    label={t('doYouHaveAFirstAidCertificate')}
                    required
                    options={[{ value: 'yes', label: t('yes') }, { value: 'no', label: t('no') }]}
                  />
                </div>
              )}

              <div className="mb-3">
                <Field
                  component={Input}
                  as="textarea"
                  rows="3"
                  name="talent"
                  label={t(isMediaCrew ? 'yourRelevantExperiencesMedia' : 'yourRelevantExperiences')}
                  required
                />
              </div>

              <div className="mb-3">
                <label>{t('yourSkills')}</label>
                {!isMediaCrew && (
                  <>
                    <Row>
                      <Col sm={6} md={3}>
                        <label>
                          <Field component="input" type="checkbox" name="skills[]" value="beer_tapping" />{' '}
                          {t('skills.beerTapping')}
                        </label>
                      </Col>
                      <Col sm={6} md={3}>
                        <label>
                          <Field component="input" type="checkbox" name="skills[]" value="decoration" />{' '}
                          {t('skills.decoration')}
                        </label>
                      </Col>
                      <Col sm={6} md={3}>
                        <label>
                          <Field component="input" type="checkbox" name="skills[]" value="fixer" /> {t('skills.fixer')}
                        </label>
                      </Col>
                      <Col sm={6} md={3}>
                        <label>
                          <Field component="input" type="checkbox" name="skills[]" value="creative" />{' '}
                          {t('skills.creative')}
                        </label>
                      </Col>
                    </Row>
                    <Row>
                      <Col sm={6} md={3}>
                        <label>
                          <Field component="input" type="checkbox" name="skills[]" value="driving_cars" />{' '}
                          {t('skills.drivingCars')}
                        </label>
                      </Col>
                      <Col sm={6} md={3}>
                        <label>
                          <Field component="input" type="checkbox" name="skills[]" value="writing" />{' '}
                          {t('skills.writing')}
                        </label>
                      </Col>
                      <Col sm={6} md={3}>
                        <label>
                          <Field component="input" type="checkbox" name="skills[]" value="mechanic" />{' '}
                          {t('skills.mechanic')}
                        </label>
                      </Col>
                      <Col sm={6} md={3}>
                        <label>
                          <Field component="input" type="checkbox" name="skills[]" value="organise" />{' '}
                          {t('skills.organise')}
                        </label>
                      </Col>
                    </Row>
                    <Row>
                      <Col sm={6} md={3}>
                        <label>
                          <Field component="input" type="checkbox" name="skills[]" value="production" />{' '}
                          {t('skills.production')}
                        </label>
                      </Col>
                      <Col sm={6} md={3}>
                        <label>
                          <Field component="input" type="checkbox" name="skills[]" value="energetic" />{' '}
                          {t('skills.energetic')}
                        </label>
                      </Col>
                      <Col sm={6} md={3}>
                        <label>
                          <Field component="input" type="checkbox" name="skills[]" value="communication" />{' '}
                          {t('skills.communication')}
                        </label>
                      </Col>
                      <Col sm={6} md={3}>
                        <label>
                          <Field component="input" type="checkbox" name="skills[]" value="flexible" />{' '}
                          {t('skills.flexible')}
                        </label>
                      </Col>
                    </Row>
                  </>
                )}
                {isMediaCrew && (
                  <>
                    <Row>
                      <Col sm={6} md={4}>
                        <label>
                          <Field component="input" type="checkbox" name="skills[]" value="fast_editing" />{' '}
                          {t('mediaSkills.fastEditing')}
                        </label>
                      </Col>
                      <Col sm={6} md={4}>
                        <label>
                          <Field component="input" type="checkbox" name="skills[]" value="creative" />{' '}
                          {t('mediaSkills.creative')}
                        </label>
                      </Col>
                      <Col sm={6} md={4}>
                        <label>
                          <Field component="input" type="checkbox" name="skills[]" value="vlogging" />{' '}
                          {t('mediaSkills.vlogging')}
                        </label>
                      </Col>
                    </Row>
                    <Row>
                      <Col sm={6} md={4}>
                        <label>
                          <Field component="input" type="checkbox" name="skills[]" value="time_lapses" />{' '}
                          {t('mediaSkills.timeLapses')}
                        </label>
                      </Col>
                      <Col sm={6} md={4}>
                        <label>
                          <Field component="input" type="checkbox" name="skills[]" value="voice_overs" />{' '}
                          {t('mediaSkills.voiceOvers')}
                        </label>
                      </Col>
                      <Col sm={6} md={4}>
                        <label>
                          <Field component="input" type="checkbox" name="skills[]" value="animation" />{' '}
                          {t('mediaSkills.animation')}
                        </label>
                      </Col>
                    </Row>
                    <Row>
                      <Col sm={6} md={4}>
                        <label>
                          <Field component="input" type="checkbox" name="skills[]" value="text_animations" />{' '}
                          {t('mediaSkills.textAnimations')}
                        </label>
                      </Col>
                      <Col sm={6} md={4}>
                        <label>
                          <Field component="input" type="checkbox" name="skills[]" value="story_telling" />{' '}
                          {t('mediaSkills.storyTelling')}
                        </label>
                      </Col>
                      <Col sm={6} md={4}>
                        <label>
                          <Field component="input" type="checkbox" name="skills[]" value="droning" />{' '}
                          {t('mediaSkills.droning')}
                        </label>
                      </Col>
                    </Row>
                  </>
                )}
              </div>

              <div className="mb-3">
                <label>{t('whatWouldYouLikeToDo')}</label>
                {!isMediaCrew && (
                  <>
                    <Row>
                      <Col sm={6} md={4}>
                        <label>
                          <Field component="input" type="checkbox" name="functionPreferences[]" value="bar" />{' '}
                          {t('functionPreferences.bar')}
                        </label>
                      </Col>
                      <Col sm={6} md={4}>
                        <label>
                          <Field component="input" type="checkbox" name="functionPreferences[]" value="animation" />{' '}
                          {t('functionPreferences.animation')}
                        </label>
                      </Col>
                      <Col sm={6} md={4}>
                        <label>
                          <Field component="input" type="checkbox" name="functionPreferences[]" value="communication" />{' '}
                          {t('functionPreferences.communication')}
                        </label>
                      </Col>
                      <Col sm={6} md={4}>
                        <label>
                          <Field component="input" type="checkbox" name="functionPreferences[]" value="production" />{' '}
                          {t('functionPreferences.production')}
                        </label>
                      </Col>
                      <Col sm={6} md={4}>
                        <label>
                          <Field component="input" type="checkbox" name="functionPreferences[]" value="medic" />{' '}
                          {t('functionPreferences.medic')}
                        </label>
                      </Col>
                      <Col sm={6} md={4}>
                        <label>
                          <Field component="input" type="checkbox" name="functionPreferences[]" value="spokesman" />{' '}
                          {t('functionPreferences.spokesman')}
                        </label>
                      </Col>
                    </Row>
                  </>
                )}
                {isMediaCrew && (
                  <>
                    <Row>
                      <Col sm={6} md={4}>
                        <label>
                          <Field component="input" type="checkbox" name="functionPreferences[]" value="photography" />{' '}
                          {t('mediaFunctionPreferences.photography')}
                        </label>
                      </Col>
                      <Col sm={6} md={4}>
                        <label>
                          <Field component="input" type="checkbox" name="functionPreferences[]" value="videography" />{' '}
                          {t('mediaFunctionPreferences.videography')}
                        </label>
                      </Col>
                    </Row>
                  </>
                )}
              </div>

              <div className={cx('mt-5', styles.formButtons)}>
                <Button type="button" level="secondary" onClick={goToPreviousStep} className="mr-3">
                  {t('back')}
                </Button>
                <Button type="submit" processing={isSubmitting}>
                  {t('save')}
                </Button>
              </div>
            </form>
          )}
        />
      </Step>
    );
  }
}

StepSkills.propTypes = {
  visible: PropTypes.bool,
};

export default withTranslation('common')(StepSkills);
